/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  OwnerDistributionsOut,
  OwnerHomeOut,
  OwnerStatementsOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getOwnerHomeResponse200 = {
  data: OwnerHomeOut
  status: 200
}

export type getOwnerHomeResponseSuccess = (getOwnerHomeResponse200) & {
  headers: Headers;
};
;

export type getOwnerHomeResponse = (getOwnerHomeResponseSuccess)

export const getGetOwnerHomeUrl = () => {




  return `/api/owner-portal/home`
}

/**
 * @summary Get Owner Home
 */
export const getOwnerHome = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getOwnerHomeResponse> => {

  return apiFetch<getOwnerHomeResponse>(getGetOwnerHomeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerHomeQueryKey = () => {
    return [
    `/api/owner-portal/home`
    ] as const;
    }


export const getGetOwnerHomeQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerHome>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerHomeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerHome>>> = ({ signal }) => getOwnerHome({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerHome>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerHomeQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerHome>>>
export type GetOwnerHomeQueryError = unknown


export function useGetOwnerHome<TData = Awaited<ReturnType<typeof getOwnerHome>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerHome>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerHome>>,
          TError,
          Awaited<ReturnType<typeof getOwnerHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerHome<TData = Awaited<ReturnType<typeof getOwnerHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerHome>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerHome>>,
          TError,
          Awaited<ReturnType<typeof getOwnerHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerHome<TData = Awaited<ReturnType<typeof getOwnerHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Owner Home
 */

export function useGetOwnerHome<TData = Awaited<ReturnType<typeof getOwnerHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerHomeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listOwnerPortalStatementsResponse200 = {
  data: OwnerStatementsOut
  status: 200
}

export type listOwnerPortalStatementsResponseSuccess = (listOwnerPortalStatementsResponse200) & {
  headers: Headers;
};
;

export type listOwnerPortalStatementsResponse = (listOwnerPortalStatementsResponseSuccess)

export const getListOwnerPortalStatementsUrl = () => {




  return `/api/owner-portal/statements`
}

/**
 * @summary List Owner Portal Statements
 */
export const listOwnerPortalStatements = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listOwnerPortalStatementsResponse> => {

  return apiFetch<listOwnerPortalStatementsResponse>(getListOwnerPortalStatementsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerPortalStatementsQueryKey = () => {
    return [
    `/api/owner-portal/statements`
    ] as const;
    }


export const getListOwnerPortalStatementsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerPortalStatementsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerPortalStatements>>> = ({ signal }) => listOwnerPortalStatements({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnerPortalStatementsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerPortalStatements>>>
export type ListOwnerPortalStatementsQueryError = unknown


export function useListOwnerPortalStatements<TData = Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerPortalStatements>>,
          TError,
          Awaited<ReturnType<typeof listOwnerPortalStatements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerPortalStatements<TData = Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerPortalStatements>>,
          TError,
          Awaited<ReturnType<typeof listOwnerPortalStatements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerPortalStatements<TData = Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Owner Portal Statements
 */

export function useListOwnerPortalStatements<TData = Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalStatements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnerPortalStatementsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getOwnerPortalStatementPdfResponse200 = {
  data: Blob
  status: 200
}

export type getOwnerPortalStatementPdfResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getOwnerPortalStatementPdfResponseSuccess = (getOwnerPortalStatementPdfResponse200) & {
  headers: Headers;
};
export type getOwnerPortalStatementPdfResponseError = (getOwnerPortalStatementPdfResponse422) & {
  headers: Headers;
};

export type getOwnerPortalStatementPdfResponse = (getOwnerPortalStatementPdfResponseSuccess | getOwnerPortalStatementPdfResponseError)

export const getGetOwnerPortalStatementPdfUrl = (statementId: number,) => {




  return `/api/owner-portal/statements/${statementId}/pdf`
}

/**
 * @summary Get Owner Portal Statement Pdf
 */
export const getOwnerPortalStatementPdf = async (statementId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getOwnerPortalStatementPdfResponse> => {

  return apiFetch<getOwnerPortalStatementPdfResponse>(getGetOwnerPortalStatementPdfUrl(statementId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerPortalStatementPdfQueryKey = (statementId: number,) => {
    return [
    `/api/owner-portal/statements/${statementId}/pdf`
    ] as const;
    }


export const getGetOwnerPortalStatementPdfQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError = HTTPValidationError>(statementId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerPortalStatementPdfQueryKey(statementId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>> = ({ signal }) => getOwnerPortalStatementPdf(statementId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: statementId !== null && statementId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerPortalStatementPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>>
export type GetOwnerPortalStatementPdfQueryError = HTTPValidationError


export function useGetOwnerPortalStatementPdf<TData = Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError = HTTPValidationError>(
 statementId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>,
          TError,
          Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerPortalStatementPdf<TData = Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError = HTTPValidationError>(
 statementId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>,
          TError,
          Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerPortalStatementPdf<TData = Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError = HTTPValidationError>(
 statementId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Owner Portal Statement Pdf
 */

export function useGetOwnerPortalStatementPdf<TData = Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError = HTTPValidationError>(
 statementId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerPortalStatementPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerPortalStatementPdfQueryOptions(statementId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listOwnerPortalDistributionsResponse200 = {
  data: OwnerDistributionsOut
  status: 200
}

export type listOwnerPortalDistributionsResponseSuccess = (listOwnerPortalDistributionsResponse200) & {
  headers: Headers;
};
;

export type listOwnerPortalDistributionsResponse = (listOwnerPortalDistributionsResponseSuccess)

export const getListOwnerPortalDistributionsUrl = () => {




  return `/api/owner-portal/distributions`
}

/**
 * @summary List Owner Portal Distributions
 */
export const listOwnerPortalDistributions = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listOwnerPortalDistributionsResponse> => {

  return apiFetch<listOwnerPortalDistributionsResponse>(getListOwnerPortalDistributionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnerPortalDistributionsQueryKey = () => {
    return [
    `/api/owner-portal/distributions`
    ] as const;
    }


export const getListOwnerPortalDistributionsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnerPortalDistributionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnerPortalDistributions>>> = ({ signal }) => listOwnerPortalDistributions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnerPortalDistributionsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnerPortalDistributions>>>
export type ListOwnerPortalDistributionsQueryError = unknown


export function useListOwnerPortalDistributions<TData = Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerPortalDistributions>>,
          TError,
          Awaited<ReturnType<typeof listOwnerPortalDistributions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerPortalDistributions<TData = Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnerPortalDistributions>>,
          TError,
          Awaited<ReturnType<typeof listOwnerPortalDistributions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnerPortalDistributions<TData = Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Owner Portal Distributions
 */

export function useListOwnerPortalDistributions<TData = Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnerPortalDistributions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnerPortalDistributionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






